import { FC, useState } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

const AccordionHelper = styled((props: AccordionProps) => <Accordion disableGutters elevation={0} square {...props} />)(
	({ theme }) => ({
		border: `1px solid ${theme.palette.divider}`,
		boxShadow: 'unset',
		borderRadius: '0.5rem',
		'&:not(:last-child)': {
			borderBottom: 0,
		},
		'&:before': {
			display: 'none',
		},
	}),
);

const Summary = styled((props: AccordionSummaryProps) => (
	<AccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ theme }) => ({
	backgroundColor: 'rgba(0, 0, 0, .03)',
	flexDirection: 'row-reverse',
	border: `1px solid ${theme.palette.divider}`,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	},
	color: '#fff',
	background: theme.palette.secondary.main,
	'& svg': {
		color: '#fff',
	},
	'& p': {
		fontWeight: theme.typography.fontWeightBold,
	},
}));

export type HelpAccordionProps = {
	content: HelpAccordionContent[];
};

export type HelpAccordionContent = {
	title: string;
	content: React.JSX.Element;
};

const HelpAccordion: FC<HelpAccordionProps> = ({ content }) => {
	const [expanded, setExpanded] = useState<string | false>(false);

	const handleChange = (panel: string) => (_event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpanded(newExpanded ? panel : false);
	};

	return (
		<div>
			{content.map((value, i) => {
				return (
					<AccordionHelper
						key={`panel${value.title.toLowerCase().replace(' ', '-')}${i}`}
						expanded={expanded === `panel${i}`}
						onChange={handleChange(`panel${i}`)}
					>
						<Summary aria-controls={`panel${i}d-content`} id={`panel${i}d-header`}>
							<Typography>{value.title}</Typography>
						</Summary>
						<AccordionDetails>{value.content}</AccordionDetails>
					</AccordionHelper>
				);
			})}
		</div>
	);
};

export default HelpAccordion;
